import { enableProdMode, StaticProvider } from '@angular/core';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { registerLicense } from '@syncfusion/ej2-base';
import * as fromEnvironment from './environments/environment';
import { platformBrowser } from '@angular/platform-browser';

registerLicense(fromEnvironment.environment.syncfusionLicenseKey);

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers: StaticProvider[] = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
}

platformBrowser(providers).bootstrapModule(AppModule)
  .catch(err => console.log(err));
